
import fetch from '../utils/fetch'
import qs from 'qs'
import download from 'downloadjs'

const baseUrl = window.SERVERAPI.API_DMPRI

// getCustSources
export function getCustomSources(params) {
  return fetch({
    baseURL: baseUrl,
    url: '/datamining/channel/getCustomSources',
    method: 'get',
    params
  })
}
// 数据挖掘栏目字典
export function getOptions(params) {
  return fetch({
    baseURL: baseUrl,
    url: '/datamining/Channel/GetOptions',
    method: 'get',
    params
  })
}
// 新闻详情
export function getArticle(params) {
  return fetch({
    baseURL: baseUrl,
    url: '/datamining/Channel/GetArticle',
    method: 'get',
    params
  })
}
// 新闻详情
export function pushSwitch(data) {
  return fetch({
    baseURL: baseUrl,
    url: '/datamining/Channel/PushSwitch',
    method: 'post',
    data
  })
}
// 移动文件夹和频道
export function moveNodeAndChannel(data) {
  return fetch({
    baseURL: baseUrl,
    url: '/datamining/Channel/MoveNodeAndChannel',
    method: 'post',
    data
  })
}
// 搜索栏目文章下载
export function getSearchListDownload(data, title) {
  return fetch({
    baseURL: baseUrl,
    url: '/datamining/Channel/GetSearchListDownload',
    method: 'post',
    responseType: 'blob',
    // headers: {
    //   'Accept': 'application/vnd.openxmlformats-officedocument' + '.spreadsheetml.sheet'
    // },
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  }).then(data => {
    download(data, title || '文章列表.csv')
  })
}

export function downloadSourceList(params, title) {
  return fetch({
    baseURL: baseUrl,
    url: '/datamining/Channel/DownloadSourceList',
    method: 'get',
    responseType: 'blob',
    // headers: {
    //   'Accept': 'application/vnd.openxmlformats-officedocument' + '.spreadsheetml.sheet'
    // },
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    },
    params: params
  }).then(data => {
    let title = `栏目ID-${params.channelId}栏目名称-${params.channelName}的数据源列表.csv`
    download(data, title)
  })
}

// // 导出数据源列表
// export function downloadSourceList(params) {
//   console.log(qs.stringify(params))
//   let title = `栏目ID-${params.channelId}栏目名称-${params.channelName}的数据源列表.csv`
//   return new Promise((resolve, reject) => {
//     let flag = download('http://testdmpri.hzfanews.com/logo_black.png') || download(baseUrl + '/datamining/Channel/DownloadSourceList?' + qs.stringify(params), title)
//     flag ? resolve() : reject(new Error('下载文件失败'))
//   })
// }

// 栏目树
export function getTreeChannel(params = { pid: -100 }) {
  return fetch({
    url: baseUrl + '/datamining/Channel/GetTree',
    method: 'get',
    params
  })
}
// 推送设置保存
export function pushSettingSave(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/PushSettingSave',
    method: 'post',
    data
  })
}
// 禁用推送设置保存
export function noPushSettingSave(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/BatchPushSwitch',
    method: 'post',
    data
  })
}
// 推送设置保存
export function batchPushSettingSave(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/BatchPushSettingSave',
    method: 'post',
    data
  })
}
// 栏目树
export function searchNodeChannel(params) {
  return fetch({
    url: baseUrl + '/datamining/Channel/SearchNode',
    method: 'get',
    params
  })
}
// 栏目树
export function getSearchList(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/GetSearchList',
    method: 'post',
    data
  })
}
// 栏目类别
export function getOnedictionaryType(params) {
  return fetch({
    url: baseUrl + '/datamining/Channel/GetOnedictionaryType',
    method: 'get',
    params
  })
}
// 栏目类别
export function getSourceType(params) {
  return fetch({
    url: baseUrl + '/datamining/Channel/GetSourceType',
    method: 'get',
    params
  })
}
export function getProvinceList(params) {
  return fetch({
    url: baseUrl + '/datamining/Channel/GetProvinceList',
    method: 'get',
    params
  })
}
export function getCountyList(params) {
  return fetch({
    url: baseUrl + '/datamining/Channel/GetCountyList',
    method: 'get',
    params
  })
}
export function getCityList(params) {
  return fetch({
    url: baseUrl + '/datamining/Channel/GetCityList',
    method: 'get',
    params
  })
}
// 获取栏目搜索Json
export function getSearchJson(params) {
  return fetch({
    url: baseUrl + '/datamining/Channel/GetSearchJson',
    method: 'get',
    params
  })
}
// 复制频道
export function copyChannelNode(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/CopyNode',
    method: 'post',
    data
  })
}
// 移动频道
export function moveNodeByChannel(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/MoveNodeByChannel',
    method: 'post',
    data
  })
}
// 移动频道
export function getPushCustomSetting(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/GetPushCustomSetting',
    method: 'get'
  })
}
// 获取栏目搜索Json
export function getChannelJson(params) {
  return fetch({
    url: baseUrl + '/datamining/Channel/Get',
    method: 'get',
    params
  })
}
// 保存栏目
export function saveChannel(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/Save',
    method: 'post',
    data
  })
}
// 获取栏目搜索Json
export function addChannelOrcommonTree(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/AddChannelOrcommonTree',
    method: 'post',
    data
  })
}
export function addChannelOrcommonTreeMore(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/AddChannelOrcommonTreeMore',
    method: 'post',
    data
  })
}
export function updatecommonTreeB(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/UpdatecommonTreeB',
    method: 'post',
    data
  })
}
// 删除频道
export function delChannel(data) {
  let params = { id: data.id }
  if (data.classes === '') {
    return delTreeNode(params)
  }
  return fetch({
    url: baseUrl + '/datamining/Channel/DelChannel',
    method: 'post',
    data: params
  })
}
// 删除频道
export function delTreeNode(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/DelTreeNode',
    method: 'post',
    data
  })
}
// 频道分类向上移动
export function channelTreeUp(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/TreeUp',
    method: 'post',
    data
  })
}
// 频道分类向上移动
export function channelTreeDown(data) {
  return fetch({
    url: baseUrl + '/datamining/Channel/TreeDown',
    method: 'post',
    data
  })
}
